// Autoplay nativo para thumbnails de video en Dawn
(function () {
  var SELECTOR = '[data-osv-video-container]';
  var containers;

  function ensureAttrs(video) {
    // Refuerza atributos que garantizan autoplay en móviles
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.loop = true;
    video.preload = 'auto';
    video.controls = false;
  }

  function insertVideo(container) {
    if (container.dataset.osvInit === '1') return null;
    var tpl = container.querySelector('template.osv-thumb__template');
    if (!tpl) return null;

    var frag = tpl.content.cloneNode(true);
    var vid = frag.querySelector('video');
    if (!vid) return null;

    ensureAttrs(vid);
    container.appendChild(frag);
    tpl.remove();

    var el = container.querySelector('video.osv-thumb__video') || container.querySelector('video');
    if (!el) return null;

    // Pausar otros al reproducir este
    el.addEventListener('play', function () {
      document.querySelectorAll(SELECTOR + ' video').forEach(function (v) {
        if (v !== el && !v.paused) {
          v.pause();
        }
      });
    });

    // Intentar reproducir sin bloquear
    var tryPlay = function () {
      var p = el.play();
      if (p && typeof p.then === 'function') {
        p.catch(function () { /* silencioso */ });
      }
    };

    if (el.readyState >= 2) {
      tryPlay();
    } else {
      el.addEventListener('loadeddata', tryPlay, { once: true });
    }

    container.dataset.osvInit = '1';
    return el;
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var c = entry.target;
      var v = c.querySelector('video');

      if (entry.isIntersecting) {
        if (!v) {
          v = insertVideo(c);
        }
        if (v) {
          ensureAttrs(v);
          v.play().catch(function () { /* silencioso */ });
        }
      } else if (v) {
        v.pause();
      }
    });
  }

  function attachObserver(root) {
    containers = (root || document).querySelectorAll(SELECTOR);
    if (!containers.length) return;

    var io = new IntersectionObserver(onIntersect, { threshold: 0.6 });
    containers.forEach(function (c) { io.observe(c); });
  }

  // Pausar cuando se activa otro media (Dawn emite este evento)
  document.addEventListener('media:activate', function (e) {
    var mediaId = e && e.detail && e.detail.mediaId;
    document.querySelectorAll(SELECTOR).forEach(function (c) {
      var v = c.querySelector('video');
      if (!v) return;
      var id = c.closest('[data-media-id]') && c.closest('[data-media-id]').getAttribute('data-media-id');
      if (id && mediaId && id !== String(mediaId)) v.pause();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    attachObserver(document);
  });

  // Soporta recargas dinámicas de secciones en el editor
  document.addEventListener('shopify:section:load', function (evt) {
    attachObserver(evt.target);
  });
})();
